import { cartLineCardExpandedStyles as styles } from "@hardware/Overrides/Widgets/Cart/CartLineCardExpanded";
import { colorStrings } from "@hardware/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.fileUploaderGridItem = {
    width: 12,
    css: css`
        flex-direction: column;

        input[type="file"] {
            display: none;
        }

        .rfq-file-upload {
            min-width: 100px;
            height: 40px;
            color: ${getColor(colorStrings.commonGlobalWhite)};
            background-color: #00656b;

            cursor: pointer;
            font-family: inherit;
            min-height: 40px;
            backface-visibility: hidden;
            transition: all 200ms ease-in-out;
            word-break: keep-all;
            padding: 0 21px;
            transform: perspective(1px);
            line-height: 40px;
            font-size: 15px;
            font-weight: 700;

            &:hover {
                background: hsl(195.5, 83.8%, 15.2%);
                border-color: hsl(195.5, 83.8%, 15.2%);
            }
        }

        .file-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .file-name-item {
            height: 40px;
            color: ${getColor(colorStrings.commonGlobalWhite)};
            background-color: ${getColor(colorStrings.secondaryMain)};
            min-width: 100px;
            padding: 10px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 10px;
            font-size: 14px;
            font-weight: 700;
        }
    `,
};

styles.fileUploader = {
    buttonProps: {
        variant: "primary",
    },
};

styles.warningIcon = {
    src: "AlertCircle",
    color: "danger.main",
    css: css`
        margin-right: 10px;
    `,
};

styles.warningSection = {
    css: css`
        display: flex;
        align-items: center;
        border: 2px solid ${getColor("danger.main")};
        padding: 5px 10px;
        margin: 10px 0 0;
        width: 100%;
        font-size: 14px;
    `,
};
